import { render, staticRenderFns } from "./IconForward10.vue?vue&type=template&id=937a0e84&scoped=true"
import script from "./IconForward10.vue?vue&type=script&lang=js"
export * from "./IconForward10.vue?vue&type=script&lang=js"
import style0 from "./IconForward10.vue?vue&type=style&index=0&id=937a0e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937a0e84",
  null
  
)

export default component.exports